<template>
  <div class="home-container">
    <el-container class="index-con">
      <el-header class="index-header">
        <div class="nav_title">
          <!-- <img class="logo_icon" src="../../static/images/logo.png" alt="" /> -->
          <span>智慧运维后台管理系统</span>
        </div>
        <div class="tuichu_box">
          <el-menu class="el-menu-demo" mode="horizontal" background-color="#255A7E" text-color="#fff"
            active-text-color="#fff">
            <el-submenu index="1" class="submenu">
              <template slot="title">
                <img class="home_touxiang" src="../../static/images/home_touxiang.png" alt="" />
                {{ userInfo.username }}
              </template>
              <div class="tuichu_menu">
                <el-menu-item index="2-1" @click="loginOut()"><img class="tuichu_icon"
                    src="../../static/images/hong_tuichu.png" alt="" />退出系统</el-menu-item>
              </div>
            </el-submenu>
          </el-menu>
        </div>
      </el-header>
      <el-container class="main-container">
        <el-aside class="asideshow">
          <el-menu collapse-transition router unique-opened class="el-menu-vertical-demo" text-color="#606266"
            background-color="#FFFFFF" :default-active="$route.path">
            <div v-for="(item, index) in menuData" :key="index">
              <el-submenu v-if="item.children" :index="item.id + ''">
                <template slot="title">
                  <img :src="item.icon" style="width: 16px; height: 16px" alt="" />
                  <span style="margin-left: 20px">{{ item.name }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item v-for="chitem in item.children" :index="chitem.href" :key="chitem.id"
                    class="children_item">
                    <!-- :class="chitem.id == 7001003 ? 'small_size':''" -->
                    <img :src="chitem.icon" style="width: 16px; height: 16px" alt="" />
                    <span>{{ chitem.name }}</span>
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <el-menu-item v-else :index="item.href" style="padding: 0 25px; box-size: border-box">
                <template slot="title">
                  <img :src="item.icon" style="width: 16px; height: 16px" alt="" />
                  <span style="margin-left: 20px">{{ item.name }}</span>
                </template>
              </el-menu-item>
            </div>
          </el-menu>
        </el-aside>
        <el-main class="content">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "index",
  data () {
    return {
      navRouteList: [],
      defaultActive: "",
      menuData: [],
      userInfo: {},
    };
  },
  // 注册组件
  components: {},
  watch: {
    // $route: {
    //   immediate: true,
    //   handler(to) {
    //     this.defaultActive = to.path;
    //   },
    // },
  },
  mounted () { },
  created () {
    this.getUserInfo()
  },
  methods: {
    getUserMenu () {
      this.$http.getMenutree({ userId: this.userInfo.userId, isTree: true }).then(res => {
        if (res.code === 0) {
          this.menuData = res.data;
        } else {
          this.menuData = [];
          this.$message.error(res.msg);
        }
      })
    },
    getUserInfo () {
      this.$http.getUserInfo().then(res => {
        if (res.code === 0) {
          this.userInfo = res.data;
          sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo))
          this.getUserMenu();
        } else {
          this.userInfo = {}
          this.$message.error(res.msg);
        }
      })
    },
    loginOut () {
      this.$confirm("此操作将退出当前登录账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.logout().then((res) => {
            if (res.code === 0) {
              window.sessionStorage.removeItem("Token");
              window.sessionStorage.removeItem("userInfo");
              this.$router.push({ path: "/login" });
              this.$message({
                type: "success",
                message: "退出成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出",
          });
        });
    },
  },
  beforeUpdate () { },
  // 挂载前状态(里面是操作)
  beforeMount () { },
};
</script>
<style lang="less">
.small_size {
  font-size: 12px !important;
}

.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.asideshow {
  width: 215px !important;
  height: calc(100vh - 67px);
  background-color: #ffffff;
  box-sizing: border-box;
}

.index-header {
  padding: 0;
  /* border-left: 2px solid #333; */
  height: 67px !important;
  width: 100%;
  background-color: #255A7E;
  color: #fff;
  display: flex;
  align-items: center;
  padding-left: 24px;
  box-sizing: border-box;
  font-family: Source Han Sans TC-Bold, Source Han Sans TC;
  font-weight: bold;
  font-size: 22px;
  justify-content: space-between;

  .tuichu_box {
    margin-right: 50px;

    .el-submenu__title {
      width: 200px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .el-submenu__title i {
      color: #ffffff;
    }
  }

  .home_touxiang {
    width: 33px;
    height: 33px;
  }

  .el-menu-demo {
    border: 0;
  }

  .nav_title {
    height: 30px;
    display: flex;
    align-items: center;

    .logo_icon {
      width: 29px;
      height: 29px;
      margin-right: 4px;
    }
  }
}

.tuichu_icon {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  margin: 0 10px;
  color: #000;
}

.main-container {
  height: 100%;
  background-color: #f2f2f2;

  .content {
    // min-width: 1640px;
    padding: 24px;
    box-sizing: border-box;
  }
}

.el-main {
  width: 100%;
  height: calc(100vh - 67px);
  // overflow: hidden;
  position: relative;
  padding: 0;

  .nav-title {
    height: 45px;
    width: 100%;
    background-color: #fff;
    margin-bottom: 5px;
    padding-left: 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .router-name {
      border: 1px solid rgba(0, 0, 0, 0.2);
      padding: 5px 10px;
      margin-right: 10px;
      border-radius: 15px;
      background-color: #fff;

      >span {
        // margin-right: 3px;
        color: #000;
        cursor: pointer;
      }

      .icon-close {
        color: #000;
        cursor: pointer;
      }
    }

    .pitch {
      background-color: #304475;
      border: 1px solid #fff;

      >span {
        color: #fff;
      }

      .icon-close {
        color: #fff;
      }
    }
  }
}

.el-menu-item-group__title {
  padding: 0 !important;
}

/deep/.el-submenu__title {
  background-color: #82a3f2 !important;
}

/deep/.el-menu-item-group__title {
  padding: 0;
}

.el-submenu__icon-arrow {
  font-size: 18px;
  right: 25px;
}

.el-submenu__title {
  padding: 0 25px !important;
}

.children_item {
  text-align: center;
}

.el-menu-item.is-active {
  color: #255A7E !important;
  background: #ecf5ff !important;
  border-right: 3px solid #255A7E;
  box-sizing: border-box;
}

.main-container {

  .el-submenu__title:hover,
  .el-menu-item:hover {
    background-color: #ecf5ff !important;
  }
}

.el-menu {
  background-color: #fff !important;
}

.tuichu_menu {
  .el-menu-item {
    background-color: #fff !important;
    color: #000 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue